var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.405 3.127a.13.13 0 0 0 .018.067l7.39 12.758L19.43 28.71a.127.127 0 0 0 0 .13.13.13 0 0 0 .112.063h3.902a.127.127 0 0 0 .11-.064l7.429-12.824a.127.127 0 0 0 0-.128l-7.43-12.824a.127.127 0 0 0-.11-.064h-3.901a.128.128 0 0 0-.137.127zM16.27 15.955a.137.137 0 0 0-.018-.069L8.706 3.064a.136.136 0 0 0-.225 0L1.02 15.881a.136.136 0 0 0 0 .137L8.564 28.84a.136.136 0 0 0 .225 0l7.462-12.817a.137.137 0 0 0 .018-.069zm6.233 1.69a.136.136 0 0 0-.062-.022h-3.895a.13.13 0 0 0-.11.064L12.06 28.71a.13.13 0 0 0 .047.176c.02.011.042.017.065.017h3.896a.136.136 0 0 0 .112-.064l6.373-11.023a.136.136 0 0 0-.05-.173zm-3.914-3.199c.018.012.04.018.063.018h3.896a.127.127 0 0 0 .11-.064.13.13 0 0 0 0-.13L16.18 3.065A.136.136 0 0 0 16.068 3h-3.896a.128.128 0 0 0-.11.194l6.48 11.206c.01.02.027.035.047.046z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHive);
export default __webpack_public_path__ + "static/media/HIVE.3f0f409eab90bbe165dc8382aebe4774.svg";
export { ForwardRef as ReactComponent };